
import BackToTop from '~/components/common/back-to-top.vue'

export default {
  components: {
    BackToTop
  }
}
